import _get from 'lodash/get';
export function getPrimaryLocation() {
  var locations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var defaultLocation = locations.find(function (_ref) {
    var primaryLocation = _ref.primaryLocation;
    return primaryLocation;
  });
  return defaultLocation || _get(locations, '[0]', {});
}
export function getPrimaryLocationId() {
  var locations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var primaryLocation = getPrimaryLocation(locations);
  var id = primaryLocation._id;
  return id;
}